import {
  Member,
  Benefit
} from '@td/membersupport';
import { get, upperFirst } from 'lodash';
import { maskedInfo } from '../../Utils';

function isHouseAccount(restrictions) {
  return !(restrictions.hasLimitedPhiAccess || restrictions.hasLimitedPiAccess);
}

function restrictedPendingMember(member, restrictions) {
  return Member({
    memberId:       get(member, 'mrnId'),
    defaultProfile: {
      benefits: [Benefit({
        mrnId: get(member, 'mrnId'),
        sponsor:           get(member, 'group.name'),
        canAccessOneapp:   get(member, 'group.oneAppFlag'),
        classification:    member.isPrimary ? 'Primary' : 'Dependent',
        isActive:          get(member, 'isActive'),
        healthPlanId:      maskedInfo,
        coverageStartDate: get(member, 'coverageStartDate'),
        coverageEndDate:   get(member, 'coverageEndDate'),
        products:          [maskedInfo],
        mrnSourceClassificationCd: get(member, 'mrnSourceClassificationCd'),
      })]
    },
    firstName:        isHouseAccount(restrictions) ? maskedInfo : get(member, 'firstName'),
    lastName:         isHouseAccount(restrictions) ? maskedInfo : get(member, 'lastName'),
    dob:              maskedInfo,
    gender:           maskedInfo,
    phoneNumber:           maskedInfo,
    city:                  maskedInfo,
    zipCode:               maskedInfo,
    residentState:         maskedInfo,
    street:                maskedInfo,
    registered:            restrictions.registered,
    canRegister:           get(member, 'isActive', false),
    groupRegistrationCode: get(member, 'groupRegistrationCode'),
    canResetPassword:      restrictions.canResetPassword,
    canImpersonate:        restrictions.canImpersonate,
    benefitToken:          get(member, 'benefitToken'),
    isRegistered:          get(member, 'isRegistered', false)
  });
}

export default restrictedPendingMember;
